import React from 'react';

type NoticeType = 'info' | 'warn' | 'danger' | 'success';
interface NoticeProps { type?: NoticeType; children: React.ReactNode; style?: React.CSSProperties; }

const colors: Record<NoticeType, { bg: string; color: string; border: string }> = {
  info: { bg: '#E6F1FB', color: '#0C447C', border: '#B5D4F4' },
  warn: { bg: '#FAEEDA', color: '#854F0B', border: '#FAC775' },
  danger: { bg: '#FCEBEB', color: '#A32D2D', border: '#F7C1C1' },
  success: { bg: '#EAF3DE', color: '#3B6D11', border: '#C0DD97' },
};

export const Notice: React.FC<NoticeProps> = ({ type = 'info', children, style }) => {
  const c = colors[type];
  return (
    <div style={{ background: c.bg, color: c.color, border: `0.5px solid ${c.border}`, borderRadius: 8, padding: '10px 12px', fontSize: 12, marginBottom: 10, ...style }}>
      {children}
    </div>
  );
};
